import PredbeznaInformaciaList from './PredbeznaInformaciaList';

export default PredbeznaInformaciaList;
